// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V9hdW","select":"styles_select__2pfOQ"};